// extracted by mini-css-extract-plugin
export var details = "_lb-0";
export var inspectorPopover = "_lb-1";